import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aux-checklist-edc-document-confirmation',
  standalone: true,
  template: `
    <div class="mb-8 flex w-[500px] flex-col items-start space-y-1">
      <span>Your document(s) have been uploaded successfully!</span>
      <span>
        You will receive an email notification when Auxilius has processed the document(s), and
        investigator data is ready for review.
      </span>
    </div>
  `,
})
export class ChecklistEdcDocumentConfirmationComponent {
  private ref = inject(CustomOverlayRef);

  closeModal() {
    this.ref.close();
  }
}
